export const alphaRegex = /[^a-zA-Z]/g;
export const numericRegex = /[^0-9]/g;

/**
 * Alphanumeric sort function for arrays of rows, structured as {value:, rowId:}
 *
 * @param {string} a
 * @param {string} b
 */
export function sortRowsAlphaNumeric(a, b) {
  let aA = a.value.replace(alphaRegex, '');
  let bA = b.value.replace(alphaRegex, '');

  if (aA === bA) {
    return compareNumeric(a.value, b.value);
  } else {
    return aA > bA ? 1 : -1;
  }
}

/** Compare the numbers within strings */
function compareNumeric(a, b) {
  let aN = parseInt(a.replace(numericRegex, ''), 10);
  let bN = parseInt(b.replace(numericRegex, ''), 10);
  if (aN === bN) {
    return 0;
  }
  else {
    return aN > bN ? 1 : -1;
  }
}

/**
 * Sort objects in ascending or descending order
 * based on the provided key which below would be name
 * sample setup: sortByKey(data, 'name', false)
 * sample object: [{name: abc}, {name: cba}]
 * when @param ascOrder is set to false it will sort in descending order
 */
export function sortByKey(data, key, ascOrder = true) {
  data.sort(function(a, b) {
    const textA = a[key].toUpperCase();
    const textB = b[key].toUpperCase();
    if (ascOrder) return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    return (textA > textB) ? -1 : (textA < textB) ? 1 : 0;
  });
}

/// Regex for file type classification
const imageRegex = /^image\/(gif|jpe?g|png|webp|tiff)$/i;
const documentRegex = /^application\/(csv|pdf|msword|(vnd\.(ms-|openxmlformats-).*))$|^text\/plain$/i;

/**
 * Uses the mime/content type of a file to return a description. The description
 *  is used to label file type icon elements.
 *
 * @param {String} type - mime/content type of the file
 * @returns {String} description of the type of file, e.g. image, document, etc.
 */
export function getFileTypeDescription(contentType) {
  if (imageRegex.test(contentType)) return 'image';
  if (documentRegex.test(contentType)) return 'document';

  return 'unknown';
}

/**
 * Upcases the first letter of the given string
 *
 * @param {string} string
 * @returns {string}
 */
export function capitalize(s) {
  return `${s[0].toUpperCase()}${s.substring(1)}`;
}

export function renderShortId(id) {
  return id.substring(0, 7).toUpperCase();
}

/**
 * @param {Number} a
 * @param {Number} b
 * @returns {Number} zero if a and b are both zero, otherwise returns a divided by b
 */
export function divOrZero(a, b) {
  if (!a || !b) return 0;
  return a / b;
}

export function isLeapYear(year) {
  return ((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0);
}

/**
 * checks if the 'element' is in the viewport
 */
export function isInViewport(element) {
  const threshold = 56;
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
    (window.innerHeight - threshold ||
      document.documentElement.clientHeight - threshold) &&
    rect.right <=
    (window.innerWidth || document.documentElement.clientWidth)
  );
}

export function getFontSize(element = document.documentElement) {
  return parseFloat(getComputedStyle(element).fontSize);
}

export function convertRemToPixels(rem) {
  return rem * getFontSize();
}
export function convertPixelsToRem(px) {
  return px / getFontSize();
}

export function sortingFunctions() {
  return {
    newest:(a, b) => {
      return b.timestamp - a.timestamp;
    },
    oldest:(a, b) => {
      return a.timestamp - b.timestamp;
    },
    highest_risk:(a, b) => {
      return b.risk_rating - a.risk_rating;
    },
    lowest_risk:(a, b) => {
      return a.risk_rating - b.risk_rating;
    },
    highest_repair_priority:(a, b) => {
      return a.priority - b.priority;
    },
    lowest_repair_priority:(a, b) => {
      return b.priority - a.priority;
    }
  };
}

export function filterBy(list, key, filter) {
  /**
   * Filters by unique key and string or number values
   */
  if (filter && key) return list.filter(item => isNaN(parseInt(item[key])) && item[key].toUpperCase() === filter);
  return key && list.filter(item => parseInt(item[key]) && item[key]) || null;
}
